import React, { Component } from 'react'
import { inject, observer } from "mobx-react"
import MyBetsCards from '../layoutComponents/MyBetsCards'

@observer(["eventStore", "UserStore", "AuthStore", "ViewStore", "web3Store"])
export default class BetSorter extends Component {

    constructor(props) {
        super(props);
        this.state = { myBetCardsArray: null }
    }

    async componentDidMount() {
        const { eventStore, UserStore } = this.props;

        let eventList = [];
        let eventIdList = [];
        let eventCardList = [];
        let betsMade = [];
        let betsTaken = [];

        this.props.wagerList.forEach(wagerObject => {
            console.log("wager obnject this time: " + JSON.stringify(wagerObject));
            let alreadyAdded = false;
            eventIdList.forEach(eventId => {
                if (eventId == wagerObject.wager.eventId) {
                    alreadyAdded = true;
                }

            });
            if (!alreadyAdded) {
                eventIdList.push(wagerObject.wager.eventId);
            }
        });

        //console.log("eventIdlist " + JSON.stringify(eventIdList));

        eventIdList.forEach(eventId => {
            eventStore.events.forEach(event => {
                if (event._id == eventId) {
                    eventList.push(event);
                }
            });

        });

        // console.log("wagerList " + JSON.stringify(this.props.wagerList));
        // console.log("eventLiust " + JSON.stringify(eventList));
        eventList.forEach(event => {
            betsMade = [];
            betsTaken = [];

            this.props.wagerList.forEach(bet => {
                if (bet.wager.eventId == event._id && bet.maker) {
                    betsMade.push(bet)
                }


                //   if ((bet.wager.eventId == event._id || bet.wager.originalEventId == event._id) && bet.taker) {
                if (bet.wager.eventId == event._id && bet.taker) {
                    betsTaken.push(bet)
                }
            });


            if (!event.isPropEvent) {
                eventCardList.push(this.renderMyBetCards(event, betsMade, betsTaken, false));
            } else {

                eventStore.events.forEach(eventInStore => {
                    if (eventInStore._id == event.originalEventId) {
                        eventCardList.push(this.renderMyBetCards(eventInStore, betsMade, betsTaken, event));
                    }
                });

            }
        });

        this.setState({ myBetCardsArray: (eventCardList.length > 0 ? eventCardList : null) });

    }

    renderMyBetCards(event, betsMade, betsTaken, propEvent) {
        let time = new Date().getTime() / 1000;
        let startTime = new Date();
        startTime.setTime(event.startTime * 1000);
        let startTimeString = startTime.toLocaleTimeString() + " - " + startTime.toLocaleDateString();
        return <MyBetsCards
            key={event._id}
            event_id={event._id}
            event={event}
            bytes32_id={event.bytes32Id}
            start_time={startTimeString}
            startTimeNumber={event.startTime}
            duration={event.duration}
            team_one={event.teams[0]}
            team_two={event.teams[1]}
            betsMade={betsMade}
            betsTaken={betsTaken}
            propEvent= {propEvent}

        />
    }
    render() {

        return (
            <div>
                {this.state.myBetCardsArray}
            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/appComponents/BetSorter.js